import React, { Component } from 'react';
import TranslationViewProps from './TranslationViewProps';

export default class TranslationView extends Component<TranslationViewProps>
{
    /* ATTRIBUTES */
    static translations: any;

    /* CONSTRUCTOR */
    constructor(props: TranslationViewProps)
    {
        super(props);

        if(!TranslationView.translations)
        {
            TranslationView.translations = require('../../translation/translations.json');
        }
    }

    /* METHODS */
    static translate(key: string, language: string = window.location.pathname.split('/')[1], upperCase: boolean = false)
    {
        try
        {
            let word: string = "";

            word = TranslationView.translations[key][language];
    
            if(word === "")
            {
                return `[${key}]`;
            }
    
            if(upperCase)
            {
                return word.toUpperCase();
            }
            
            return word;
        }

        catch(ex)
        {
            return `[${key}]`;
        }
    }

    /* RENDERING */
    render()
    {
        const { children, language, upperCase, style, onClick } = this.props
        
        return (
            <span onClick={onClick} style={style}>
                {TranslationView.translate(children, language, upperCase)}
            </span>
        );
    }
}